import { Button, Modal, ModalDialog } from '@mui/joy';

import { DatasetPicker } from '@/components/DatasetPicker';
import { DatasetDataType, DatasetSchema } from '@/types/schema';

export function CloneDatasetExamplesModal(props: {
  examples?: string[];
  open: boolean;
  onClose: () => void;
  sourceDatasetId: string | null;
  onSubmit: () => void;
  sourceDataType?: DatasetDataType;
  targetDatasetId: string | undefined;
  setTargetDatasetId: (datasetId: string | undefined) => void;
  isLoading: boolean;
  prefilledData?: Partial<DatasetSchema>;
}) {
  return (
    <Modal open={props.open} onClose={props.onClose} sx={{ zIndex: 5 }}>
      <ModalDialog>
        <div className="flex min-w-[400px] flex-col gap-4">
          <div className="text-lg">
            Clone
            {props.examples?.length
              ? ` ${props.examples.length} example${
                  props.examples.length !== 1 ? 's' : ''
                }`
              : ' all examples'}
          </div>
          <DatasetPicker
            datasetId={props.targetDatasetId}
            onChange={props.setTargetDatasetId}
            filter={{
              data_type: props.sourceDataType
                ? [props.sourceDataType, 'kv']
                : undefined,
            }}
            label={''}
            placeholder="Choose target dataset"
            prefilledData={props.prefilledData}
          />
          <div className="flex gap-2">
            <Button variant="outlined" color="neutral" onClick={props.onClose}>
              Cancel
            </Button>
            <Button
              variant="solid"
              disabled={!props.targetDatasetId}
              color="primary"
              loading={props.isLoading}
              onClick={() => props.onSubmit()}
            >
              Submit
            </Button>
          </div>
        </div>
      </ModalDialog>
    </Modal>
  );
}
